export interface BrandManifest {
  id: string;
  displayName: string;
  theme: {
    tokens: Record<string, string>;
  };
  assets: {
    logo: string;
    wordmark?: string;
    sidebar?: string;
    favicon?: string;
    appleTouchIcon?: string;
    pwaIcon192?: string;
    pwaIcon512?: string;
  };
  metadata?: {
    title?: string;
    description?: string;
    themeColor?: string;
  };
  copy?: Record<string, string>;
  features?: Record<string, boolean>;
  api?: {
    baseUrl?: string;
    headers?: Record<string, string>;
    tenantSlug?: string;
    tenantId?: string;
  };
}

export const DEFAULT_MANIFEST: BrandManifest = {
  id: 'default',
  displayName: 'ALTO Works',
  theme: {
    tokens: {
      '--brand-name': 'ALTO Works',
      '--brand-primary': '#102A43',
      '--brand-accent': '#B56A2C'
    }
  },
  assets: {
    logo: 'brands/default/logo.png',
    wordmark: 'brands/default/alto_works_horizontal.svg',
    sidebar: 'brands/default/alto_works_sidebar.png',
    favicon: 'brands/default/favicon.png',
    appleTouchIcon: 'brands/default/apple-touch-icon.png',
    pwaIcon192: 'brands/default/pwa-192.png',
    pwaIcon512: 'brands/default/pwa-512.png'
  },
  metadata: {
    title: 'ALTO Works',
    description: 'ALTO Works — Raw Inputs. Trusted Outputs.',
    themeColor: '#102A43'
  },
  copy: {},
  features: {},
  api: {}
};
